import React from 'react';
import { useStyleConfig, VStack } from '@chakra-ui/react';
const VStackWrapper = (props) => {
    const { variant, ...rest } = props;
    const styles = useStyleConfig('VStack', { variant });
    return React.createElement(VStack, { __css: styles, ...rest });
};
export default VStackWrapper;
